import apiClient from './apiClient';
import { buildQueryString } from './queryParams';

function withMinDelayThunk(thunk, minDelay = 1000) {
  return async (arg, thunkAPI) => {
    const [result] = await Promise.all([
      thunk(arg, thunkAPI),
      new Promise(resolve => setTimeout(resolve, minDelay))
    ]);
    return result;
  };
}

function withMinDelay(promise, minDelay = 1000) {
  return Promise.all([
    promise,
    new Promise(resolve => setTimeout(resolve, minDelay))
  ]).then(([result]) => result);
}

export {
  apiClient,
  buildQueryString,
  withMinDelayThunk,
  withMinDelay
}
